import React, { useEffect, useState } from 'react';
import { constants } from '../../../misc/constants';
import { BaseConfig } from '../../BaseConfig';
import GeneralButtonWithText from '../../helpers/GeneralButtonWithText';

import './SmeDebugUI.css'
const SmeDebugUI = (props: SmeDebugUIConfig) => {
	const [showDebugUI, setShowDebugUI] = useState(false);
	
	const [apneaInductionTimeInSeconds, setApneaInductionTimeInSeconds] = useState(800);
	const [apneaApneaTimeInSeconds, setApneaApneaTimeInSeconds] = useState(180);

	const [vitalsBpNumerator, setVitalsBpNumerator] = useState(100);
	const [vitalsBpDenominator, setVitalsBpDenominator] = useState(90);
	const [vitalsMinBpNumerator, setVitalsMinBpNumerator] = useState(50);
	const [vitalsMinBpDenominator, setVitalsMinBpDenominator] = useState(33);
	const [vitalsMaxBpNumerator, setVitalsMaxBpNumerator] = useState(220);
	const [vitalsMaxBpDenominator, setVitalsMaxBpDenominator] = useState(110);
	const [vitalsMaxHr, setVitalsMaxHr] = useState(205);
	const [vitalsHr, setVitalsHr] = useState(60);
	const [vitalsHrMultiplier, setVitalsHrMultiplier] = useState(1);
	const [vitalsBpMultiplier, setVitalsBpMultiplier] = useState(1);
	const [vitalsEtc02, setVitalsEtc02] = useState(35);
	const [vitalsRR, setVitalsRR] = useState(30);
	const [vitalsSa02, setVitalsSa02] = useState(100);
	const [vitalsSa02Multiplier, setVitalsSa02Multiplier] = useState(1);


	const setVariable = (key: string, value: any) => {
		(window as any)[key] = value;
	}

	const isNumber = (e: any) => {
		const re = /^[0-9\b]+$/;
		if (e.target.value === '' || re.test(e.target.value)) {
			return true;
		}

		return false;
	}

	const getVariable = (key: string, defaultVal: string) => {
		return (window as any)[key] ?? defaultVal;
	}
	
	const updateChanges = () => {
		setVariable(constants.smeDebug.variables.apneaInductionTime, 
					apneaInductionTimeInSeconds);

		setVariable(constants.smeDebug.variables.apneaApneaTime, 
					apneaApneaTimeInSeconds);

		setVariable(constants.smeDebug.variables.vitalsBpNumerator, 
			vitalsBpNumerator);
		setVariable(constants.smeDebug.variables.vitalsBpDenominator, 
			vitalsBpDenominator);

		setVariable(constants.smeDebug.variables.vitalsMinBpNumerator, 
			vitalsMinBpNumerator);
		setVariable(constants.smeDebug.variables.vitalsMinBpDenominator, 
			vitalsMinBpDenominator);

		setVariable(constants.smeDebug.variables.vitalsMaxBpNumerator, 
			vitalsMaxBpNumerator);
		setVariable(constants.smeDebug.variables.vitalsMaxBpDenominator, 
			vitalsMaxBpDenominator);

		setVariable(constants.smeDebug.variables.vitalsHr, 
			vitalsHr);
		setVariable(constants.smeDebug.variables.vitalsSa02, 
			vitalsSa02);
		setVariable(constants.smeDebug.variables.vitalsEtc02, 
			vitalsEtc02);
		setVariable(constants.smeDebug.variables.vitalsRR, 
			vitalsRR);
		setVariable(constants.smeDebug.variables.vitalsBpMultiplier, 
			vitalsBpMultiplier);
		setVariable(constants.smeDebug.variables.vitalsSa02Multiplier, 
			vitalsSa02Multiplier);
		setVariable(constants.smeDebug.variables.vitalsMaxHr, 
			vitalsMaxHr);
		setVariable(constants.smeDebug.variables.vitalsHrMultiplier, 
			vitalsHrMultiplier);
		var evts = (window as any)[constants.smeDebug.globalEvents.smeDebugUpdate];
		for(var prop in evts) {
			evts[prop]();
		}
	}
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			left: '0',
			top: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			{/* <GeneralButtonWithText parameters= {{
				ignoreTabbing: true,
				text: 'Edit',
				top: '190px',
				left: '1615px',
				width: '140px',
				isDisabled: false,
				srcIdle: "./assets/images/main-menu/button_menu_exit.png",
				srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
				srcDisabled: null,
				customImgStyle: {
				},
				customButtonStyle : {
				},
				customTextStyle: {
					fontSize: '12pt'
				},
				onClicked: () => {
					setShowDebugUI(true);
				}
			}}/> */}

			<div className='modal-bg monitor-container' style={{
				position: 'absolute',
				left: '0',
				top: '0',
				width: '100%',
				height: '100%',
				pointerEvents: 'all',
				display: showDebugUI ? 'block' : 'none'
			}}>
				<div style={{
					position: 'absolute',
					left: '50%',
					top: '50%',
					transform: 'translate(-50%, -50%)',
					width: '940px',
					height: '540px',
					backgroundColor: 'black'
				}}>
					<p className='title-font' style={{
						position: 'absolute',
						top: '20px',
						width: '100%',
						fontSize: '20pt',
						textAlign: 'center',
						margin: '0'
					}}>Update values for testing in current playthrough of the scenario</p>
					<div style={{
						margin: '10px',
						position: 'absolute',
						top: '65px',
						width: '920px',
						height: '360px',
						overflow: 'auto'
					}}>
						<div style={{
							position: 'relative',
						}}>
							<p className='title-font sme-stuff-entry-title'>Apnea Clock</p>

							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Induction Time (In Seconds): 
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={apneaInductionTimeInSeconds} onChange={(e) => {
														if(isNumber(e)) {
															setApneaInductionTimeInSeconds(parseInt(e.target.value))
														}
													}}/>
							</div>
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Apnea Time (In Seconds): 
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={apneaApneaTimeInSeconds}onChange={(e) => {
														if(isNumber(e)) {
															setApneaApneaTimeInSeconds(parseInt(e.target.value))
														}
													}}/>
							</div>
						</div>
						<div style={{
							position: 'relative',
						}}>
							<p className='title-font sme-stuff-entry-title'>Vitals</p>

							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Blood Pressure: 
								</p>
								<div className='sme-stuff-column 
											sme-stuff-right-column'>
									<input style={{
											width: '33%'
										}} type="text" value={vitalsBpNumerator} onChange={(e) => {
										if(isNumber(e)) {
											setVitalsBpNumerator(parseInt(e.target.value))
										}
									}}/>
									<p className='title-font 
													sme-stuff-entry-text' style={{
											width: '33%',
											textAlign: 'center'
										}}>
										/
									</p>
									<input style={{
												width: '33%'
											}} type="text" value={vitalsBpDenominator} onChange={(e) => {
											if(isNumber(e)) {
												setVitalsBpDenominator(parseInt(e.target.value))
											}
										}}/>
								</div>
								
							</div>
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Min Blood Pressure: 
								</p>
								<div className='sme-stuff-column 
											sme-stuff-right-column'>
									<input style={{
											width: '33%'
										}} type="text" value={vitalsMinBpNumerator} onChange={(e) => {
										if(isNumber(e)) {
											setVitalsMinBpNumerator(parseInt(e.target.value))
										}
									}}/>
									<p className='title-font 
													sme-stuff-entry-text' style={{
											width: '33%',
											textAlign: 'center'
										}}>
										/
									</p>
									<input style={{
												width: '33%'
											}} type="text" value={vitalsMinBpDenominator} onChange={(e) => {
											if(isNumber(e)) {
												setVitalsMinBpDenominator(parseInt(e.target.value))
											}
										}}/>
								</div>
								
							</div>

							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Max Blood Pressure: 
								</p>
								<div className='sme-stuff-column 
											sme-stuff-right-column'>
									<input style={{
											width: '33%'
										}} type="text" value={vitalsMaxBpNumerator} onChange={(e) => {
										if(isNumber(e)) {
											setVitalsMaxBpNumerator(parseInt(e.target.value))
										}
									}}/>
									<p className='title-font 
													sme-stuff-entry-text' style={{
											width: '33%',
											textAlign: 'center'
										}}>
										/
									</p>
									<input style={{
												width: '33%'
											}} type="text" value={vitalsMaxBpDenominator} onChange={(e) => {
											if(isNumber(e)) {
												setVitalsMaxBpDenominator(parseInt(e.target.value))
											}
										}}/>
								</div>
								
							</div>
							{/* <div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Blood Pressure Multiplier
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsBpMultiplier}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsBpMultiplier(parseInt(e.target.value))
														}
													}}/>
							</div> */}
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Heart Rate
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsHr}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsHr(parseInt(e.target.value))
														}
													}}/>
							</div>
							{/* <div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Heart Rate Multiplier
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsHrMultiplier}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsHrMultiplier(parseInt(e.target.value))
														}
													}}/>
							</div> */}
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Sa02
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsSa02}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsSa02(parseInt(e.target.value))
														}
													}}/>
							</div>
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Etc02
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsEtc02}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsEtc02(parseInt(e.target.value))
														}
													}}/>
							</div>
							{/* <div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Sa02 Multiplier
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsSa02Multiplier}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsSa02Multiplier(parseInt(e.target.value))
														}
													}}/>
							</div> */}
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Max Heart Rate
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsMaxHr}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsMaxHr(parseInt(e.target.value))
														}
													}}/>
							</div>
							<div className='sme-stuff-row'>
								<p className='title-font 
												sme-stuff-entry-text 
												sme-stuff-column
												sme-stuff-left-column'>
									Respiration Rate
								</p>
								<input className='sme-stuff-column 
													sme-stuff-right-column' 
													type="text" value={vitalsRR}onChange={(e) => {
														if(isNumber(e)) {
															setVitalsRR(parseInt(e.target.value))
														}
													}}/>
							</div>
						</div>
					</div>

					<div style={{
						position: 'absolute',
						top: '449px',
						left: '0',
						width: '100%'
					}}>
						<GeneralButtonWithText parameters= {{
							text: 'Update',
							top: '0',
							left: '300px',
							width: '140px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
							},
							customButtonStyle : {
							},
							customTextStyle: {
								fontSize: '12pt'
							},
							onClicked: () => {
								updateChanges();
								setShowDebugUI(false);
							}
						}}/>
						<GeneralButtonWithText parameters= {{
							text: 'Cancel',
							top: '0',
							left: '500px',
							width: '140px',
							isDisabled: false,
							srcIdle: "./assets/images/main-menu/button_menu_exit.png",
							srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
							srcDisabled: null,
							customImgStyle: {
							},
							customButtonStyle : {
							},
							customTextStyle: {
								fontSize: '12pt'
							},
							onClicked: () => {
								setShowDebugUI(false);
							}
						}}/>
					</div>
					
					
				</div>
			</div>
		</div>
	);

};

export interface SmeDebugUIConfig extends BaseConfig{
}

export default SmeDebugUI;